import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders  } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Centerlink } from "./centerlink.model";

@Injectable({
  providedIn: 'root'
})
export class CenterlinkService {

  constructor(private httpClient:HttpClient) { }
  selectedCenterlink : Centerlink;
  selectedCenterlinkList : Centerlink[]= [];
  searchedCenterlinkList : Centerlink[] =[];

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDCentreLink(centerlink:Centerlink){

    centerlink.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    centerlink.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    centerlink.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    centerlink.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    centerlink.CreatedDate  = new Date((localStorage.getItem("CreatedDate")));
    centerlink.ModifiedDate = new Date((localStorage.getItem("ModifiedDate")));

    let body =  centerlink;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CenterLink/IUD', body,{headers: headers});
  }
  
//   FetchCenterLinkByCenterLinkId(centerlink) {

//     let body =  centerlink;
//     const headers = new HttpHeaders();
//     headers.set('Content-Type', 'application/json; charset=utf-8');
//     return this.httpClient.post<any>( this.getBaseUrl() +  'api/CenterLink/Fetch', body,{headers: headers});
// }

  // ------------Load controls ------------------------------
  
  GetMemberGroupList(centreId: any){

    this.selectedCenterlink  = new Centerlink();
    // this.selectedCustomer.IsCustomerSearch =false;
    this.selectedCenterlink.CentreId = + centreId;
    this.selectedCenterlink.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCenterlink.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCenterlink.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCenterlink.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedCenterlink;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/MemberGroup', body,{headers: headers});
    // return this.httpClient.post<any>( this.getBaseUrl() +  'api/Group/FetchList', body,{headers: headers});
  }

  // GetMemberGroupList(){

  //   let body =  null;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   // return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/MemberGroup', body,{headers: headers});
  //   return this.httpClient.post<any>( this.getBaseUrl() +  'api/Group/FetchList', body,{headers: headers});
  // }
  
  GetCentreList(){
    
    this.selectedCenterlink  = new Centerlink();
    // this.selectedCustomer.IsCustomerSearch =false;
    this.selectedCenterlink.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCenterlink.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCenterlink.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCenterlink.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCenterlink.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body =  this.selectedCenterlink;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/Center/FetchList', body,{headers: headers});
   }

   GetCentreLinkList(){
    this.selectedCenterlink  = new Centerlink();
    this.selectedCenterlink.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCenterlink.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedCenterlink.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];

    let body =  this.selectedCenterlink;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CenterLink/FetchList', body,{headers: headers});
   }

   GetCentreLinkById(centerlinkId : number){
    
    this.selectedCenterlink.Id = + centerlinkId;
    this.selectedCenterlink.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCenterlink.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCenterlink.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedCenterlink.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body =  this.selectedCenterlink;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CenterLink/Fetch', body,{headers: headers});
   }

}
